export enum StockRoutePathNames {
  STOCK = 'stock',
  SITES = '',
  ID = ':id',
  UNIT = 'business-unit',
  UNIT_ID = ':unitId?',
}
